import type { UserWithAggInfo } from "@/api/custom_types";
import { useTranslation } from "@/hooks/useTranslation";
import { formatNumber } from "@/utils/tools";
import {
	Chip,
	Icon,
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@st-marketplace/ui";

interface ResolvedCommissionCellProps {
	resolved: UserWithAggInfo["resolved_sys_commission_rate"];
}

const ResolvedCommissionCell: React.FC<ResolvedCommissionCellProps> = ({
	resolved,
}) => {
	const { t } = useTranslation();

	if (resolved == null) return <>-</>;

	const isLocal = resolved.type === "LOCAL";

	return (
		<span className="inline-flex items-center gap-1">
			<span className="tabular-nums">{formatNumber(resolved.value)}</span>
			<Tooltip>
				<TooltipTrigger asChild>
					<span className="inline-flex cursor-help">
						<Chip variant={isLocal ? "info" : "muted"} size="sm">
							<span className="inline-flex items-center gap-0.5">
								{t(
									isLocal
										? "admin.users.commissionSourceCustom"
										: "admin.users.commissionSourceGlobal",
								)}
								<Icon
									name="information-line"
									size="xs"
									className="opacity-70"
								/>
							</span>
						</Chip>
					</span>
				</TooltipTrigger>
				<TooltipContent>
					<p>
						{t(
							isLocal
								? "admin.users.commissionSourceTooltipCustom"
								: "admin.users.commissionSourceTooltipGlobal",
						)}
					</p>
					<p>{t("admin.users.commissionSourceTooltipHint")}</p>
				</TooltipContent>
			</Tooltip>
		</span>
	);
};

export default ResolvedCommissionCell;
